import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var PdfShortcutSvg = function PdfShortcutSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B30B00",
    fillRule: "evenodd",
    d: "M2 0h20a2 2 0 0 1 2 2v20a2 2 0 0 1-2 2H8.708A9 9 0 0 0 0 9.223V2a2 2 0 0 1 2-2",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m11.754 4.514-.133-.032-.131.04a1.5 1.5 0 0 0-.814.594c-.192.285-.285.627-.313.996-.054.724.138 1.662.52 2.78q.195.567.4 1.114a21.3 21.3 0 0 1-1.351 3.737c.305.567.55 1.171.73 1.803a22 22 0 0 1 2.93-.555q.317-.039.626-.069a7.7 7.7 0 0 0 2.07 1.424c.735.345 1.378.464 1.907.392.536-.073.963-.348 1.174-.768a1.28 1.28 0 0 0-.098-1.293c-.26-.39-.713-.66-1.29-.75-.787-.124-2.005-.147-3.38-.042-.946-1.024-1.647-2.354-2.269-3.94q.138-.545.26-1.11c.254-1.16.354-2.11.266-2.818-.089-.706-.4-1.332-1.104-1.503m.112 1.628c.058.464.012 1.14-.161 2.046-.277-.886-.379-1.546-.345-2.001.02-.254.079-.413.145-.512a.5.5 0 0 1 .132-.13c.089.073.183.233.229.597m-1.196 8.37a21 21 0 0 0 1.225-3.033c.428.928.913 1.78 1.5 2.529-.887.111-1.816.276-2.725.503m6.044.928a6.7 6.7 0 0 1-1.048-.612c.895-.028 1.65.007 2.16.087.36.056.538.205.614.317s.071.217.034.29c-.035.07-.14.188-.414.225-.28.038-.724-.014-1.346-.306",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.313 23.583q-1.793 0-3.053-1.245T0 19.295q0-1.27.647-2.288a4.36 4.36 0 0 1 1.725-1.57H0V14h5.39v5.39H3.954v-2.97a2.72 2.72 0 0 0-1.797.934 2.8 2.8 0 0 0-.719 1.917q0 1.201.839 2.038a2.78 2.78 0 0 0 2.037.837z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
};
export var PdfShortcut = function PdfShortcut(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: PdfShortcutSvg
  }));
};